import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../utils/firebase'; // adjust if needed

const EditWhatsappModal = ({ isOpen, onClose, email }) => {
  const [whatsappNumber, setWhatsappNumber] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length > 12) return;
    if (!/^\d*$/.test(value)) return;
    setWhatsappNumber(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!whatsappNumber) {
      toast.error('WhatsApp Number is required!');
      return;
    }
    if (whatsappNumber.length !== 12) {
      toast.error('WhatsApp Number must be exactly 12 digits!');
      return;
    }

    try {
      const userDocRef = doc(db, 'userDetails', email); // Use passed email
      await updateDoc(userDocRef, {
        whatsappNumber: whatsappNumber,
      });

      toast.success('WhatsApp Number updated successfully!');
      setWhatsappNumber('');
      onClose();
    } catch (error) {
      console.error('Error updating WhatsApp Number', error);
      toast.error('Failed to update WhatsApp Number.');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Update WhatsApp Number</h2>
          <button onClick={onClose} className="text-gray-600 hover:text-gray-900 text-2xl">&times;</button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
           
            <input
              type="text"
              name="whatsappNumber"
              value={whatsappNumber}
              onChange={handleChange}
              className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
              placeholder="Enter 12 digit number"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
          >
            Update Number
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditWhatsappModal;
